import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

import { saleTagColor } from './sale_tag';

export const defaultStyles = {
  priceContainer: {},
  priceContainerChild: {
    fontWeight: 500,
    fontSize: 16,
    textAlign: 'center',
  },
  salePrice: {
    margin: '0 10px',
    textDecoration: 'line-through',
    textDecorationColor: saleTagColor,
  },
};

export default function Price({ result, calculatedPricing, styles }) {
  const isLoaded = !!result;

  if (!isLoaded) {
    return (
      <div style={styles.priceContainer}>
        <Skeleton />
      </div>
    );
  }

  if (calculatedPricing.onSale) {
    return (
      <div style={styles.priceContainer}>
        <div style={{ ...styles.salePrice, ...styles.priceContainerChild }}>
          $
          {calculatedPricing.price}
        </div>
        <div style={styles.priceContainerChild}>
          $
          {result.dblProductSalePrice}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.priceContainer}>
      $
      {calculatedPricing.price}
    </div>
  );
}

Price.propTypes = {
  result: PropTypes.shape({
    dblProductSalePrice: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }).isRequired,
  calculatedPricing: PropTypes.shape({
    onSale: PropTypes.bool,
    price: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }).isRequired,
  styles: PropTypes.shape({
    priceContainer: PropTypes.shape({}),
    priceContainerChild: PropTypes.shape({}),
    salePrice: PropTypes.shape({}),
  }),
};

Price.defaultProps = {
  styles: defaultStyles,
};
